// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../logoo.png';
import logo1 from '../logo1.png';
import logoAlex from '../logoAlex2.png';
import logoUAE from '../logoUAE1.png';
import '../css/style.css';

const Footer = () => {
  return (
    <>
      <style>{`
        .footer-modern {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          color: #e6ecff;
          position: relative;
          overflow: hidden;
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
        }
        
        .footer-modern::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        }
        
        .footer-modern::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="rgba(255,255,255,0.02)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          opacity: 0.3;
          pointer-events: none;
        }
        
        .footer-modern .footer-title {
          color: #ffffff;
          border-bottom: 2px solid rgba(255, 102, 0, 0.6);
          padding-bottom: 8px;
          margin-bottom: 20px;
          font-weight: 600;
          font-size: 18px;
          position: relative;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .footer-modern .footer-title::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 30px;
          height: 2px;
          background: #ff6600;
          transition: width 0.3s ease;
        }
        
        .footer-modern .footer-title:hover::after {
          width: 50px;
        }
        
        .footer-modern .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .footer-modern .footer-links li {
          margin-bottom: 12px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding-bottom: 8px;
          transition: all 0.3s ease;
          position: relative;
        }
        
        .footer-modern .footer-links li::before {
          content: '';
          position: absolute;
          left: -10px;
          top: 50%;
          width: 0;
          height: 2px;
          background: #ff6600;
          transition: width 0.3s ease;
          transform: translateY(-50%);
        }
        
        .footer-modern .footer-links li:hover {
          border-bottom-color: rgba(255, 102, 0, 0.4);
          transform: translateX(5px);
        }
        
        .footer-modern .footer-links li:hover::before {
          width: 8px;
        }
        
        .footer-modern .footer-links a { 
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          transition: all 0.3s ease;
          font-weight: 500;
          font-size: 14px;
          display: block;
          padding: 4px 0;
          position: relative;
        }
        
        .footer-modern .footer-links a:hover { 
          color: #ff6600;
          transform: translateX(3px);
        }
        
        .footer-social a {
          display: inline-flex; 
          align-items: center; 
          justify-content: center;
          width: 40px; 
          height: 40px; 
          border-radius: 50%; 
          margin-right: 10px;
          color: #fff; 
          background: rgba(255, 255, 255, 0.1); 
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
          text-decoration: none;
          position: relative;
          overflow: hidden;
        }
        
        .footer-social a::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s ease;
        }
        
        .footer-social a:hover::before {
          left: 100%;
        }
        
        .footer-social a:hover { 
          transform: translateY(-3px) scale(1.1); 
          background: #ff6600; 
          color: #ffffff;
          box-shadow: 0 4px 12px rgba(255, 102, 0, 0.3);
        }
        
        .footer-bottom { 
          border-top: 1px solid rgba(255, 255, 255, 0.15); 
          color: rgba(255, 255, 255, 0.7);
          background: rgba(0, 0, 0, 0.1);
          position: relative;
        }
        
        .footer-bottom::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255, 102, 0, 0.5), transparent);
        }
        
        .footer-bottom a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          transition: all 0.3s ease;
          position: relative;
        }
        
        .footer-bottom a::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 1px;
          background: #ff6600;
          transition: width 0.3s ease;
        }
        
        .footer-bottom a:hover {
          color: #ff6600;
        }
        
        .footer-bottom a:hover::after {
          width: 100%;
        }
        
        .footer-logo { 
          filter: drop-shadow(0 2px 6px rgba(0,0,0,0.25));
          height: 50px;
          width: auto;
          transition: all 0.3s ease;
        }
        
        .footer-logo:hover {
          transform: scale(1.05);
          filter: drop-shadow(0 4px 12px rgba(0,0,0,0.35));
        }
        
        .footer-text {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 15px;
        }
        
        .footer-email {
          color: #ff6600;
          font-weight: 600;
          font-size: 14px;
          margin-top: 10px;
          transition: all 0.3s ease;
        }
        
        .footer-email:hover {
          color: #ffffff;
          transform: translateX(3px);
        }
        
        .footer-contact-info {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 15px;
          border-left: 3px solid #ff6600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .footer-contact-info::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 102, 0, 0.1), transparent);
          transition: left 0.5s ease;
        }
        
        .footer-contact-info:hover::before {
          left: 100%;
        }
        
        .footer-contact-info:hover {
          background: rgba(255, 255, 255, 0.08);
          transform: translateX(3px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        .footer-contact-info i {
          color: #ff6600;
          margin-right: 8px;
          width: 16px;
          transition: all 0.3s ease;
        }
        
        .footer-contact-info:hover i {
          transform: scale(1.2);
        }
        
        @media (max-width: 768px) {
          .footer-modern .footer-title {
            font-size: 16px;
          }
          
          .footer-modern .footer-links a {
            font-size: 13px;
          }
          
          .footer-social a {
            width: 35px;
            height: 35px;
            margin-right: 8px;
          }
          
          .footer-contact-info {
            padding: 12px;
          }
        }
      `}</style>

      <footer className="footer footer-modern pt-5 pb-0" style={{ position: 'relative', zIndex: 1003 }}>
        <div className="container">
          <div className="row">

            {/* Company Info */}
            <div className="col-md-6 mb-4">
              {/* Petrochoice Entities Title */}
              <div className="text-center mb-4">
                <h2 className="text-white mb-2" style={{ fontSize: '1.8rem', fontWeight: 'bold', fontFamily: 'Poppins, sans-serif' }}>
                  PETROCHOICE ENTITIES
                </h2>
                <div style={{ width: '100px', height: '3px', background: '#ff6b35', margin: '0 auto' }}></div>
              </div>
              
              {/* Entity 1 - Cairo */}
              <div className="d-flex align-items-center mb-4" style={{ 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '10px', 
                padding: '20px',
                border: '1px solid rgba(255, 107, 53, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.4)';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 53, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.2)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div className="me-4" style={{ flexShrink: 0 }}>
                  <img src={logo1} alt="Cairo Logo" style={{ 
                    width: '70px', 
                    height: '62px',
                  }} />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-2" style={{ color: '#ff6b35', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Petrochoice Integrated Services - Egypt
                  </h6>
                  <div className="d-flex align-items-center mb-1">
                    <i className="fas fa-map-marker-alt me-2" style={{ color: '#ff6b35', fontSize: '14px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.9rem' }}>
                      12A/2 Hussein Hamouda Street, Takseem Allasilki, New Maadi, Cairo, Egypt
                    </span>
                  </div>
                </div>
              </div>

              {/* Entity 2 - Alexandria */}
              <div className="d-flex align-items-center mb-4" style={{ 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '10px', 
                padding: '20px',
                border: '1px solid rgba(255, 107, 53, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.4)';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 53, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.2)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div className="me-4" style={{ flexShrink: 0 }}>
                  <img src={logoAlex} alt="Alexandria Logo" style={{ 
                    width: '70px', 
                    height: '62px',
                  }} />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-2" style={{ color: '#ff6b35', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Petrochoice Integrated Services FZ - Egypt
                  </h6>
                  <div className="d-flex align-items-center mb-1">
                    <i className="fas fa-map-marker-alt me-2" style={{ color: '#ff6b35', fontSize: '14px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.9rem' }}>
                      Free Zone, Al Amria, Alexandria, Egypt
                    </span>
                  </div>
                </div>
              </div>

              {/* Entity 3 - UAE */}
              <div className="d-flex align-items-center mb-4" style={{ 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '10px', 
                padding: '20px',
                border: '1px solid rgba(255, 107, 53, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.4)';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 53, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                e.target.style.border = '1px solid rgba(255, 107, 53, 0.2)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                <div className="me-4" style={{ flexShrink: 0 }}>
                  <img src={logoUAE} alt="UAE Logo" style={{ 
                    width: '70px', 
                    height: '62px',
                  }} />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-2" style={{ color: '#ff6b35', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Petrochoice Integrated Services FZ LLC - UAE
                  </h6>
                  <div className="d-flex align-items-center mb-1">
                    <i className="fas fa-map-marker-alt me-2" style={{ color: '#ff6b35', fontSize: '14px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.9rem' }}>
                      Hulaila Industrial zone – FZ –Ras Al Khaimah – United Arab Emirates
                    </span>
                  </div>
                </div>
              </div>

              {/* Email Section */}
              <div className="text-center mt-4">
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <i className="fas fa-envelope me-2" style={{ color: '#ff6b35', fontSize: '16px' }}></i>
                  <span className="text-white" style={{ fontSize: '1rem', fontWeight: '500' }}>
                    info@petrochoice.org
                  </span>
                </div>
                
                {/* Social Icons */}
                <div className="footer-social">
                  <a href="https://www.facebook.com/profile.php?id=61552399684686&locale=ar_AR" target="_blank" rel="noreferrer" aria-label="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/petrochoice-integrated-services/posts/?feedView=all" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Integrated Drilling Management Services */}
            <div className="col-md-2 mb-4">
              <h5 className="footer-title">Integrated Drilling Management Services</h5>
              <ul className="footer-links">
                <li><NavLink to="/services/integrated-drilling">Integrated Drilling</NavLink></li>
                <li><NavLink to="/services/integrated-drilling/light-wims">LD-WIMS</NavLink></li>
                <li><NavLink to="/services/integrated-drilling/fd-wms">FD-WMS <span className="badge bg-warning ms-1">Coming Soon</span></NavLink></li>
              </ul>

              <h5 className="footer-title mt-4">Software Services</h5>
              <ul className="footer-links">
                <li><NavLink to="/services/software/uniface360">Uniface360</NavLink></li>
                <li><NavLink to="/services/software/npt-break">NPT Break</NavLink></li>
                <li><NavLink to="/services/software/unitrack">UniTrack</NavLink></li>
                <li><NavLink to="/services/software/jms">JMS</NavLink></li>
              </ul>
            </div>

            {/* All Other Services */}
            <div className="col-md-2 mb-4">
              <h5 className="footer-title">Technical Services</h5>
              <ul className="footer-links">
                <li><NavLink to="/services/wellhead">Wellhead Services</NavLink></li>
                <li><NavLink to="/services/manpower">Manpower Supply</NavLink></li>
                <li><NavLink to="/services/mud-services">Mud Services</NavLink></li>
                <li><NavLink to="/services/seismic-acquisition">Seismic Acquisition</NavLink></li>
              </ul>

              <h5 className="footer-title mt-4">Support Services</h5>
              <ul className="footer-links">
                <li><NavLink to="/services/supply-chain">Supply Chain</NavLink></li>
                <li><NavLink to="/services/inspection">Inspection (NDT)</NavLink></li>
                <li><NavLink to="/services/hse-services">HSE Services</NavLink></li>
              </ul>
            </div>

            {/* Company */}
            <div className="col-md-2 mb-4">
              <h5 className="footer-title">Company</h5>
              <ul className="footer-links">
                <li><NavLink to="/about">About Us</NavLink></li>
                <li><NavLink to="/mission-vision">Mission & Vision</NavLink></li>
                <li><NavLink to="/agencies">Agencies</NavLink></li>
                <li><NavLink to="/careers">Careers</NavLink></li>
                <li><NavLink to="/contact">Contact</NavLink></li>
                <li><NavLink to="/quote">Quote</NavLink></li>
                <li><NavLink to="/blog">Blog</NavLink></li>
                <li><NavLink to="/news">News</NavLink></li>
              </ul>
            </div>

          </div>
        </div>
        <div className="footer-bottom mt-4 py-3">
          <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div style={{ fontSize: '0.95rem' }}>
              © {new Date().getFullYear()} Petrochoice. All rights reserved.
            </div>
            <div style={{ fontSize: '0.9rem' }}>
              <NavLink to="/privacy" className="me-3">Privacy Policy</NavLink>
              <NavLink to="/terms">Terms of Service</NavLink>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
